import { createSelector } from 'reselect';

import { TInitialState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

export const getSelectedProductsIds = createSelector(
    [
        (state: TInitialState) => state.productFilters,
    ],
    (filters) => {
        const selectedProducts = filters.filter(filter => filter.checked);

        // Если не выбрано ни одного продукта, то возвращаем интернет по умолчанию
        if (!selectedProducts.length) {
            return [EProductsId.internet];
        }

        const productIdsArray = new Set<EProductsId>([]);

        selectedProducts.forEach(({ id }) => {
            // Выбран продукт 'Интернет+ТВ'
            if (typeof id === 'undefined') {
                productIdsArray.add(EProductsId.tv);
                productIdsArray.add(EProductsId.internet);
            } else {
                productIdsArray.add(id);
            }
        });

        return [...productIdsArray];
    },
);
